/**
 * AddBulk types
 * Shared types for bulk upload functionality
 */

import { SelectOption } from "components/dropdown/Dropdown";

export enum PAGES {
  "SITE" = "site",
  "ITEM" = "item",
  "CONTACT" = "contact",
  "ASSET" = "asset",
  "CATALOGUE_ITEMS" = "catalogue",
  "USER" = "user",
  "SURVEY" = "survey",
}

/**
 * Props for AddBulk component
 */
export type AddBulkProps = {
  fieldName: string;
  fieldLabel: string;
  url: string;
  noun: PAGES;
  fileInstructions?: string;
  downloadFile?: boolean;
  onDone: () => void;
  isRedirected?: boolean;
  parentSelectedIdName?: string;
  parentSelectedId?: number;
  extraPayloadItems?: { [fieldName: string]: any };
};

/**
 * Form data structure for bulk upload
 */
export type UploadData = {
  contactTypesId?: number;
  contactTypesIds?: SelectOption[];
  siteData?: SelectOption[];
  projectData?: SelectOption[];
  sitesID?: number | null;
  projectsID?: number | null;
  csvFile: any | null;
  action?: string;
  actions?: SelectOption[];
  surveyTemplatesId?: number;
  surveyTemplates?: SelectOption[];
  programmesId?: number;
  programmes?: SelectOption[];
};

/**
 * API response structure for successful upload
 */
export type UploadResponse = {
  countDuplicates: number;
  countInserted: number;
  countUploaded: number;
};

/**
 * Configuration for entity-specific upload behavior
 */
export type EntityConfig = {
  fieldName: string;
  endpoint?: string;
  requiresValidation?: boolean;
};

/**
 * API payload structure for CSV upload
 */
export type UploadPayload = {
  BulkClientFile?: File;
  BulkItemFile?: File;
  CsvFile?: File;
  ContactTypesId?: number;
  SitesId?: number | null;
  ProjectsId?: number | null;
  Action?: string;
  ProgrammesId?: number;
  SurveyTemplatesId?: number;
  [key: string]: any;
};
